
    // IMPORTS
    import { computed, defineComponent, ref, watch } from 'vue'
    import { useRoute } from 'vue-router'
    import { buildLocalization, buildPartnerNavigation, OrderProposalApi } from '@/util'
    import PortalPage from '@/components/common/portal-page.vue'
    import { RouterView } from 'vue-router';
    import { INavigationItem } from '@/types/INavigationItem'

    export default defineComponent({
        name: 'shoppingCart',

        components: {
            PortalPage,
            RouterView
        },

        setup() {
            /********************************************************************************************************************
             INIT
             ********************************************************************************************************************/
            const route = useRoute()
            const { localize } = buildLocalization()
            const { navigationItems: partnerNavigationItems } = buildPartnerNavigation()
            const orderProposalApi = new OrderProposalApi()

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const proposalNo = ref<number | null>(null)

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const proposalId = computed(() => route.query.id as string | undefined)
            const isNamedMode = computed(() => !!proposalId.value)
            const bannerTitle = computed<string | null>(() => {
                if (isNamedMode.value && proposalNo.value) {
                    return `${localize('ProposedOrder')} JSP-${String(proposalNo.value).padStart(7, '0')}`
                }
                if (isNamedMode.value) {
                    return localize('ProposedOrder')
                }
                return localize('shoppingCart')
            })

            const bannerNavigationItems = computed<INavigationItem[]>(() => {
                return partnerNavigationItems.value
            })

            const computedData = { bannerTitle, bannerNavigationItems }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            const publicMethods = { localize }

            /********************************************************************************************************************
             PRIVATE METHODS
             ********************************************************************************************************************/
            function loadProposalTitle(id: string) {
                orderProposalApi.getById(id)
                    .then(response => {
                        proposalNo.value = response.data.orderProposalNo
                    })
                    .catch(() => {
                        proposalNo.value = null
                    })
            }

            /********************************************************************************************************************
             WATCHERS
             ********************************************************************************************************************/
            watch(proposalId, (newId) => {
                if (newId) {
                    loadProposalTitle(newId)
                } else {
                    proposalNo.value = null
                }
            }, { immediate: true })

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...computedData, ...publicMethods }
        }
    });
